/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Trigger a given notification
 *
 * @param  {Object} state
 * @return {Void}
 */
export const ADD_NOTIFICATION = (state, notification) => {
    state.notifications.unshift(notification)
}

/**
 * Remove a given notification
 *
 * @param  {Object} state
 * @return {Void}
 */
export const REMOVE_NOTIFICATION = (state, notification) => {
    state.notifications.splice(state.notifications.indexOf(notification), 1)
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

export default {
    RESET_STATE,
    ADD_NOTIFICATION,
    REMOVE_NOTIFICATION
}



// WEBPACK FOOTER //
// ./src/state/mutations.js